import { jsxs, jsx } from "react/jsx-runtime";
const IconZoomSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.006 15.007h-1.053l-.373-.36a8.628 8.628 0 0 0 2.093-5.64A8.666 8.666 0 0 0 9.007.34 8.666 8.666 0 0 0 .34 9.007a8.666 8.666 0 0 0 8.667 8.666c2.146 0 4.12-.786 5.64-2.093l.36.373v1.054l6.666 6.653 1.987-1.987-6.654-6.666Zm-8 0c-3.32 0-6-2.68-6-6s2.68-6 6-6 6 2.68 6 6-2.68 6-6 6Zm.667-9.334H8.34V8.34H5.673v1.333H8.34v2.667h1.333V9.673h2.667V8.34H9.673V5.673Z" })
    ]
  }
);
export {
  IconZoomSvg
};
